// src/firebase/messaging.js
import {getMessaging, getToken, onMessage, isSupported} from "firebase/messaging";
import firebaseApp from "./firebase";
import notificationApi from "@/apis/Notification.api";

// Biến toàn cục để giữ messaging instance
let messaging = null;

/**
 * Kiểm tra trình duyệt có hỗ trợ FCM không (quan trọng cho Safari/iOS)
 */
export const checkMessagingSupport = async () => {
    try {
        const supported = await isSupported(); // check async
        if (supported) {
            messaging = getMessaging(firebaseApp);
            console.log("Trình duyệt hỗ trợ Firebase Messaging");
        } else {
            console.warn("Trình duyệt KHÔNG hỗ trợ Firebase Messaging");
        }
        return supported;
    } catch (e) {
        console.error("Lỗi khi kiểm tra hỗ trợ Messaging:", e);
        return false;
    }
};


// Gọi hàm này để lấy token khi cần
export const requestForToken = async () => {
    try {
        const permission = await Notification.requestPermission();

        if (permission !== "granted") {
            console.warn(" Người dùng từ chối nhận thông báo");
            return null;
        }

        if (!messaging) {
            console.warn("messaging chưa được khởi tạo");
            return null;
        }

        const swRegistration = await navigator.serviceWorker.ready;

        const currentToken = await getToken(messaging, {
            vapidKey: "BNuNOb6fZe0UalnKM1s_wD6xz7Ynf896iEnFVvupLkYT6nt-nxEEK774h5fFg06AC2-wPc9e_pEGvMb0UYgSBJw", // lấy từ Firebase Console > Cloud Messaging
            serviceWorkerRegistration: swRegistration,
        });

        if (currentToken) {
            try {
                return currentToken;
            }
            catch (error) {
                console.error(error);
                return null;
            }
        } else {
            console.warn("Không lấy được token, có thể do user chưa cấp quyền");
            return null;
        }
    } catch (err) {
        console.error("Lỗi khi lấy token:", err);
        return null;
    }
};

/**
 * Lắng nghe message khi app đang mở (foreground)
 */
export const onMessageListener = () => {
    if (!messaging) {
        console.warn("messaging chưa được khởi tạo, không thể lắng nghe tin nhắn");
        return () => {};
    }

    return new Promise(resolve => {
        onMessage(messaging, payload => {
            console.log("Nhận được message khi app mở:", payload);
            resolve(payload);
        });
    });
};
